// Groups: the third sidebar level, between a submenu and its articles
// (plan 2026-10-13-docs-sidebar-groups-within-a-submenu).
//
// A group IS a folder: `docs/<section>/<submenu>/<group>/<article>.mdx`, so the
// URL follows the sidebar. This registry is the one place a group's
// customer-facing label and position live; validation (validation.ts, run by
// both the runtime manifest and scripts/validate-docs.ts) rejects a group
// folder without an entry here AND an entry here without an article, so the
// two can never drift.
//
// Labels ship in the frontend bundle like every docs body (CLAUDE.md content
// rule): never name an unreleased or NDA feature here, even when the group's
// articles are flag-gated.
//
// Relative imports only (this file is loaded by the tsx validator script).

export interface DocGroupEntry {
  /** Customer-facing English label shown in the sidebar, category page and breadcrumbs. */
  label: string;
  /** Position within the submenu; lower first. */
  order: number;
}

/** Keyed by `<section>/<submenu>/<group folder>`, lowercase. */
export const DOC_GROUPS: Readonly<Record<string, DocGroupEntry>> = {
  "activation/campaigns/building": { label: "Building a campaign", order: 1 },
  "activation/campaigns/frontends": { label: "Frontends", order: 2 },
  "activation/campaigns/measuring": { label: "Measuring", order: 3 },
  "activation/segments/building": { label: "Building a segment", order: 1 },
  "activation/segments/exporting": { label: "Exporting and syncing", order: 2 },
  "activation/segments/managing": { label: "Managing segments", order: 3 },
  "data-management/sources/built-in": { label: "Built-in sources", order: 3 },
  "data-management/sources/connecting": { label: "Connecting a source", order: 1 },
  "data-management/sources/freshness": { label: "Freshness and lineage", order: 5 },
  "data-management/sources/managing": { label: "Managing a source", order: 4 },
  "data-management/sources/profiles": { label: "Customer profiles", order: 6 },
  "data-management/sources/your-own-data": { label: "Bringing your own data", order: 2 },
  "insights/analyst/reading": { label: "Reading an analysis", order: 1 },
  "insights/analyst/setting-up": { label: "Setting up the Analyst", order: 2 },
  "insights/dashboards/building": { label: "Building and sharing", order: 3 },
  "insights/dashboards/chart-gallery": { label: "Chart types", order: 5 },
  "insights/dashboards/controls": { label: "Chart controls", order: 4 },
  "insights/dashboards/using": { label: "Using a dashboard", order: 2 },
  "insights/dashboards/verity-dashboards": { label: "Verity dashboards", order: 1 },
};

export function groupKey(section: string, submenu: string, folder: string): string {
  return `${section}/${submenu}/${folder}`;
}

/** The group folder of a slug (`section/submenu/group/article`), or undefined when ungrouped. */
export function groupFolderOf(slug: string): string | undefined {
  const parts = slug.split("/");
  return parts.length === 4 ? parts[2] : undefined;
}
